import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { cn } from "@/lib/utils";

export type TimePeriod = "day" | "week" | "month" | "year";

interface TimePeriodSelectorProps {
  selectedPeriod: TimePeriod;
  onPeriodChange: (period: TimePeriod) => void;
  darkMode?: boolean;
}

export const TimePeriodSelector = ({
  selectedPeriod,
  onPeriodChange,
  darkMode = false,
}: TimePeriodSelectorProps) => {
  const triggerClass = cn(
    "text-sm py-1 font-medium rounded-md transition-all",
    darkMode
      ? "data-[state=active]:bg-primary data-[state=active]:text-primary-foreground text-muted-foreground data-[state=active]:shadow-sm"
      : "data-[state=active]:bg-white data-[state=active]:text-foreground text-foreground0 data-[state=active]:shadow-sm"
  );

  return (
    <Tabs
      value={selectedPeriod}
      onValueChange={(value) => onPeriodChange(value as TimePeriod)}
      className="w-full"
    >
      <TabsList
        className={cn(
          "grid grid-cols-4 p-1 rounded-xl h-10 w-full border",
          darkMode ? "bg-muted border-border" : "bg-muted border-border"
        )}
      >
        <TabsTrigger value="day" className={triggerClass}>
          Day
        </TabsTrigger>
        <TabsTrigger value="week" className={triggerClass}>
          Week
        </TabsTrigger>
        <TabsTrigger value="month" className={triggerClass}>
          Month
        </TabsTrigger>
        <TabsTrigger value="year" className={triggerClass}>
          Year
        </TabsTrigger>
      </TabsList>
    </Tabs>
  );
};
